@for (notificacao of topo(); track notificacao.id) {
  @if (mobile()) {
    <div class="lnot-banner-area" #areaBanner @entradaBanner>
      <div class="lnot-banner" role="button" tabindex="0" (click)="abrir(notificacao)" (keydown.enter)="abrir(notificacao)">
        <span class="lnot-sino">
          <img src="./assets/icones/redesign/modulos/lembretes/icon-signal-lembrete.svg" alt="" />
          @if (total() > 1) {
            <span class="lnot-banner-contador">{{ total() }}</span>
          }
        </span>
        <div class="lnot-banner-textos">
          <span class="lnot-banner-linha">
            <span class="lnot-banner-rotulo">Lembrete</span>
            <span class="lnot-banner-contato">· {{ notificacao.contatoNome }}</span>
          </span>
          <span class="lnot-banner-descricao">
            @if (total() > 1) {
              1 de {{ total() }} ·
            }
            {{ notificacao.titulo }}
          </span>
        </div>
        @if (podeAgir(notificacao)) {
          <button type="button" class="lnot-banner-acao lnot-banner-acao-adiar" aria-label="Adiar 5 minutos" (click)="adiar(notificacao, undefined, $event)">
            <img class="lnot-icone" src="./assets/icones/redesign/utils/clock-gray.svg" alt="" />
          </button>
          <button type="button" class="lnot-banner-acao lnot-banner-acao-concluir" aria-label="Concluir lembrete" (click)="concluir(notificacao, $event)">
            <img class="lnot-icone" src="./assets/icones/redesign/utils/check-green.svg" alt="" />
          </button>
        } @else {
          <button type="button" class="lnot-fechar" aria-label="Dispensar lembrete" (click)="dispensar(notificacao, $event)">
            <img src="./assets/icones/redesign/utils/close-gray.svg" alt="" />
          </button>
        }
      </div>
    </div>
  } @else {
    <div class="lnot-pilha" @entradaCard [class.lnot-pilha-oculta]="idModal() === notificacao.id">
      <div class="lnot-card" #card>
        <div class="lnot-card-cabecalho">
          <span class="lnot-sino">
            <img src="./assets/icones/redesign/modulos/lembretes/icon-signal-lembrete.svg" alt="" />
          </span>
          <div class="lnot-card-cabecalho-textos">
            <span class="lnot-card-titulo-linha">
              <span class="lnot-card-titulo">Lembrete</span>
              @if (total() > 1) {
                <span class="lnot-card-contador">1 de {{ total() }}</span>
              }
            </span>
            <span class="lnot-card-subtitulo">
              {{ quando(notificacao) }} ·
              @if (total() > 1) {
                você tem {{ total() }} lembretes
              } @else {
                {{ notificacao.dataHora | date: 'HH:mm' }}
              }
            </span>
          </div>
          <button type="button" class="lnot-fechar" aria-label="Dispensar lembrete" (click)="dispensar(notificacao)">
            <img src="./assets/icones/redesign/utils/close-gray.svg" alt="" />
          </button>
        </div>

        <div class="lnot-card-contato">
          <img class="lnot-avatar" [src]="fotoContato(notificacao)" alt="" (error)="marcarFotoIndisponivel(notificacao)" />
          <span class="lnot-card-contato-nome">{{ notificacao.contatoNome }}</span>
        </div>

        <span class="lnot-card-descricao">{{ notificacao.titulo }}</span>
        @if (notificacao.anotacao) {
          <span class="lnot-card-anotacao lnot-texto-duas-linhas">{{ notificacao.anotacao }}</span>
        }

        <div class="lnot-card-acoes">
          @if (podeAgir(notificacao)) {
            <button type="button" class="lnot-botao lnot-card-botao" (click)="adiar(notificacao)">
              <img class="lnot-icone" src="./assets/icones/redesign/utils/clock-gray.svg" alt="" />
              Adiar
            </button>
            <button type="button" class="lnot-botao lnot-card-botao" (click)="concluir(notificacao)">
              <img class="lnot-icone" src="./assets/icones/redesign/utils/check-green.svg" alt="" />
              Concluir
            </button>
          }
          <button type="button" class="lnot-botao lnot-botao-primario lnot-card-botao" (click)="abrir(notificacao)">Abrir</button>
        </div>
      </div>
      @if (total() > 1) {
        <div class="lnot-fantasma lnot-fantasma-1"></div>
        @if (total() > 2) {
          <div class="lnot-fantasma lnot-fantasma-2"></div>
        }
      }
    </div>
  }
}

@if (notificacaoModal(); as notificacao) {
  <app-lembrete-notificacao-modal
    [notificacao]="notificacao"
    [mobile]="mobile()"
    [origem]="origemModal"
    [acionavel]="podeAgir(notificacao)"
    (fechar)="fecharModal($event)"
    (adiar)="adiar(notificacao, $event)"
    (concluir)="concluir(notificacao)"
    (dispensar)="dispensar(notificacao)"
    (abrirContato)="abrirContato(notificacao, $event)" />
}
